var QueryBuilderLogicType;
(function (QueryBuilderLogicType) {
    QueryBuilderLogicType[QueryBuilderLogicType["And"] = 1] = "And";
    QueryBuilderLogicType[QueryBuilderLogicType["Or"] = 2] = "Or";
})(QueryBuilderLogicType || (QueryBuilderLogicType = {}));
;
export default QueryBuilderLogicType;
